<template>
  <ToolboxMenu :expanded="isExpanded" @onToggleClick="toggleMenu" />
</template>

<script>
import ToolboxMenu from '../general/navigation/ToolboxMenu.vue'

export default {
  name: 'MapviewerToolbox',
  components: {
    ToolboxMenu
  },
  emits: ['toggleToolboxMenu'],
  data() {
    return {
      isExpanded: false
    }
  },

  methods: {
    toggleMenu: function () {
      this.isExpanded = !this.isExpanded
      this.$emit('toggleToolboxMenu', this.isExpanded)
    }
  }
}
</script>

<style lang="scss" scoped>
@use '@/styles/variables.scss' as old-variables;
.app-toolbox-menu-paragraph {
  color: old-variables.$color-text-white;
}
</style>
